module.exports = __webpack_public_path__ + "static/logo-61ed22b174a37cb0b97b532a15834c66.svg";